module.exports = __webpack_public_path__ + "img/submit.2a5411f2.png";